import React from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  TextField
} from "@mui/material";
import { toast } from "react-toastify";

export default function PasoBeneficiarios({ data, update, next, back }) {

  const beneficiarios = data.beneficiarios || [];

  const add = () => {
    if (beneficiarios.length >= 2) return;
    update({
      beneficiarios: [
        ...beneficiarios,
        { nombre: "", id: "", porcentaje: "" }
      ]
    });
  };

  const change = (i, field, value) => {
    const copia = [...beneficiarios];
    copia[i][field] = value;
    update({ beneficiarios: copia });
  };

  const eliminar = (i) => {
    const copia = [...beneficiarios];
    copia.splice(i, 1);
    update({ beneficiarios: copia });
  };

  const continuar = () => {
    const total = beneficiarios.reduce(
      (acc, b) => acc + Number(b.porcentaje || 0),
      0
    );

    // Si no hay beneficiarios → permitir continuar
    if (beneficiarios.length === 0) {
      return next();
    }

    // Si hay beneficiarios → validar porcentaje
    if (total !== 100) {
      toast.error("La suma de porcentajes debe ser exactamente el 100%");
      return;
    }

    next();
  };

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} mb={2}>
        Beneficiarios
      </Typography>

      {beneficiarios.map((b, i) => (
        <Grid container spacing={2} key={i} mb={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Nombres y apellidos"
              fullWidth
              value={b.nombre}
              onChange={(e) => change(i, "nombre", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              type="number"
              label="Número de identificación"
              fullWidth
              value={b.id}
              onChange={(e) => change(i, "id", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              label="Porcentaje del auxilio"
              type="number"
              fullWidth
              value={b.porcentaje}
              onChange={(e) => change(i, "porcentaje", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={1} display="flex" alignItems="center">
            <Button
              color="error"
              onClick={() => eliminar(i)}
              sx={{ minWidth: 0 }}
            >
              X
            </Button>
          </Grid>
        </Grid>
      ))}

      {/* BOTÓN AGREGAR */}
      <Button
        variant="outlined"
        onClick={add}
        disabled={beneficiarios.length >= 2}
        sx={{
          mb: 3,
          opacity: beneficiarios.length >= 2 ? 0.5 : 1,
          cursor: beneficiarios.length >= 2 ? "not-allowed" : "pointer",
          borderRadius: "20px",
          textTransform: "none"
        }}
      >
        + Agregar beneficiario
      </Button>

      {/* LEYENDA */}
      <Box
        sx={{
          backgroundColor: "#f5f7fa",
          border: "1px solid #e0e0e0",
          borderRadius: "10px",
          p: 2,
          mb: 3
        }}
      >
        <Typography variant="body2" sx={{ color: "#444", lineHeight: 1.6 }}>
          Debes registrar mínimo una (1) y máximo dos (2) personas mayores de edad como beneficiarios. Ellos recibirán el auxilio familiar en caso de tu fallecimiento.
          <br /><br />
          Este beneficio económico se activa desde el primer descuento de tu ahorro obligatorio y representa un respaldo institucional para tus familiares en momentos difíciles.
        </Typography>
      </Box>

      {/* BOTONES PIE DE PÁGINA */}
      <Box display="flex" justifyContent="center" gap={3} mt={4}>
        <Button
          variant="outlined"
          size="large"
          onClick={back}
          sx={{
            borderRadius: "20px",
            px: 4,
            textTransform: "none",
            fontSize: "1rem"
          }}
        >
          Atrás
        </Button>

        <Button
          variant="contained"
          size="large"
          onClick={continuar}
          sx={{
            borderRadius: "20px",
            px: 4,
            textTransform: "none",
            fontSize: "1rem"
          }}
        >
          Siguiente
        </Button>
      </Box>
    </Box>
  );
}